import React, { useEffect, useState, useContext, useCallback } from "react";

import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle/PageTitle";
import Api from "../../../constant/Api";
import { useHistory } from "react-router-dom";
import { getRequest } from "../../../constant/ApiService";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useStyles from "../../../components/styles/styles";
import Input from "../../../components/utils/Input";
import { Pagination } from "@material-ui/lab";

const OperatorCustomer = () => {
  const [items, setItems] = useState([]);
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState([]);
  const [customerSearch, setCustomerSearch] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    code: "",
  });
 

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getCustomerList = () => {
    getRequest(
      `${Api.GetCargoOwnersOperatorList}?FirstName=${
        customerSearch.firstName
      }&LastName=${customerSearch.lastName}&PhoneNumber=${
        customerSearch.phone
      }&PageNumber=${page}&PageSize=20`,
    ).then(res => {
      setItems(res && res.data);
      setCount(res && res.data.count)
    });
  };
  useEffect(() => {
    getCustomerList();
  }, []);
  const handleChange = (event, newPage) => {
    setPage(newPage);
    getCustomerList();
  };
  return (
    <Grid>
      <PageTitle title="لیست متصدی  " />
      <Grid container>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام مشتری </label>
          <Input
            name="firstName"
            value={customerSearch.firstName}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                firstName: target.value,
              }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام خانوادگی مشتری </label>
          <Input
            name="lastName"
            value={customerSearch.lastName}
            onChange={({ target }) =>
              setCustomerSearch(state => ({ ...state, lastName: target.value }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن مشتری </label>
          <Input
            name="phone"
            value={customerSearch.phone}
            onChange={({ target }) =>
              setCustomerSearch(state => ({ ...state, phone: target.value }))
            }
            type="tel"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>کد مشترک </label>
          <Input
            name="code"
            value={customerSearch.code}
            onChange={({ target }) =>
              setCustomerSearch(state => ({ ...state, code: target.value }))
            }
            type="number"
          />
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          direction="row-reverse"
          style={{ padding: "20px 0" }}
        >
          <Grid style={{ display: "flex" }}>
            <Button
              variant="contained"
              style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
              onClick={getCustomerList}
            >
              جستجو کنید
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>ردیف</TableCell>
              <TableCell>شناسه</TableCell>
              <TableCell> نام</TableCell>
              <TableCell>نام خانوادگی</TableCell>
              <TableCell>شناسه ملی</TableCell>
              <TableCell>تلفن</TableCell>
              <TableCell>کد  مشترک</TableCell>
              <TableCell>کد معرف دعوت کننده</TableCell>
              <TableCell>امتیاز</TableCell>
              <TableCell>اقدام</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.lists &&
              items.lists.length > 0 &&
              items.lists.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.id}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.firstName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.lastName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.security_Number}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.phone}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.reagent_Code}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.inviter_Code}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailOperatorCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.rate}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="primary"
                        >
                          مدیریت مالی
                        </Button>
                      </MenuItem>

                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="secondary"
                        >
                          قراردادی
                        </Button>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
       <Pagination
                      count={items.lists && items.lists.length > 0 ? Math.ceil(count / 20) : 0}
                      page={page}
                      onChange={handleChange}
                      color="primary"
                      variant="outlined"
                      shape="rounded"
                      size="large"
                      style={{ marginTop: "2vh" }}
                 />
    </Grid>
  );
};
export default OperatorCustomer;
